import {
	Container,
	type ContainerProps,
	type ContainerSpacing,
} from '@/modules/foundation/components/container';
import FoundationGallery from '@/modules/foundation/components/gallery';
import type {ImageWeb} from '@/modules/foundation/components/image/types';
import type {KeyedArray} from '@/modules/foundation/shared/types';

type Props = {
	images: KeyedArray<ImageWeb>;
	width?: ContainerProps['width'];
	spacingTop?: ContainerSpacing;
	spacingBottom?: ContainerSpacing;
};

export const Gallery = ({spacingBottom, spacingTop, images, width}: Props) => {
	return (
		<>
			<Container width={width} spacingBottom={spacingBottom} spacingTop={spacingTop}>
				<FoundationGallery images={images} />
			</Container>
		</>
	);
};
